export default function getOvatAmtService() {
    return function (array) {
        let adValoremTotal = 0,
            totalAmt = 0,
            totalTaxamt = 0
        array && array.forEach(item => {
            adValoremTotal += (item.adValoremTotal || item.afterTaxAmount || 0)*1
            totalAmt += (item.totalAmt || item.beforeTaxAmount || 0)*1
            totalTaxamt += (item.totalTaxamt || item.taxAmount || 0)*1
        })
        return {
            adValoremTotal:adValoremTotal.toFixed(2),
            totalAmt:totalAmt.toFixed(2),
            totalTaxamt:totalTaxamt.toFixed(2)
        }
    }
}


// WEBPACK FOOTER //
// ./src/common/services/getOvatAmtService.js